var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 rounded-lg shadow-sm bg-white"},[_c('CommonTable',{attrs:{"table-data":_vm.tableData,"name-column-props":{
      prop: 'name',
      label: '地区',
      width: '160px',
    },"fixLength":2,"currency":_vm.currency}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }